import { useState, useContext, useEffect } from "react";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";
import "./forgotPassword.css";
import usersRequest from "../../request/usersRequest";
import BannerMessageFixed from "../common/bannerMessageFixed/bannerMessageFixed";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
    const { language } = useContext(CombinedContext);

    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [banner, setBanner] = useState({ text: "", type: "info", exiting: false });

    const navigate = useNavigate();

    useEffect(() => {
        if (!banner.text) return;
        const exitTimer  = setTimeout(() => setBanner((prev) => ({ ...prev, exiting: true })), 2500);
        const removeTimer = setTimeout(() => setBanner({ text: "", type: "info", exiting: false }), 2750);
        return () => { clearTimeout(exitTimer); clearTimeout(removeTimer); };
    }, [banner.text]);

    async function handleSubmit(e) {
        e.preventDefault();
        if (!email) return;
        try {
            setLoading(true);
            await usersRequest.forgotPassword(email);
            navigate("/confirmforgotpassword");
        } catch (err) {
            console.error(err);
            setBanner({ text: translations[language].forgotPassword.toast.error, type: "error", exiting: false });
        } finally {
            setLoading(false);
        }
    }

    const handleKeyDown = (e) => { if (e.key === "Enter") handleSubmit(e); };

    return (
        <div className="sf-fp-root">
            <div className="sf-fp-card">
                <h1 className="sf-fp-title">{translations[language].forgotPassword.title}</h1>
                <p className="sf-fp-sub">{translations[language].forgotPassword.subtitle}</p>

                <div className="sf-fp-field">
                    <label className="sf-fp-label">{translations[language].forgotPassword.email}</label>
                    <input
                        type="email"
                        className="sf-fp-input"
                        placeholder={translations[language].forgotPassword.email}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onKeyDown={handleKeyDown}
                        required
                    />
                </div>

                <button className="sf-fp-submit" onClick={handleSubmit} disabled={loading}>
                    {loading
                        ? translations[language].forgotPassword.sending
                        : translations[language].forgotPassword.send}
                </button>

                <BannerMessageFixed text={banner.text} type={banner.type} exiting={banner.exiting} />
            </div>
        </div>
    );
};

export default ForgotPassword;

// import { useState, useContext, useEffect } from "react";
// import { CombinedContext } from "../../context/combinedContext";
// import translations from "../../translations/translations";
// import "./forgotPassword.css";
// import usersRequest from "../../request/usersRequest";
// import BannerMessageFixed from "../common/bannerMessageFixed/bannerMessageFixed";
// import { useNavigate } from "react-router-dom";

// const ForgotPassword = () => {
// 	const { language } = useContext(CombinedContext);

// 	const [email, setEmail] = useState("");
// 	const [loading, setLoading] = useState(false);
// 	const [banner, setBanner] = useState({ text: "", type: "info", exiting: false });

// 	const navigate = useNavigate();

// 	useEffect(() => {
// 		if (!banner.text) return;

// 		const exitTimer = setTimeout(() => setBanner((prev) => ({ ...prev, exiting: true })), 2500);
// 		const removeTimer = setTimeout(() => setBanner({ text: "", type: "info", exiting: false }), 2750);

// 		return () => {
// 			clearTimeout(exitTimer);
// 			clearTimeout(removeTimer);
// 		};
// 	}, [banner.text]);

// 	async function handleSubmit(e) {
// 		e.preventDefault();
// 		if (!email) return;

// 		try {
// 			setLoading(true);
// 			await usersRequest.forgotPassword(email);
// 			navigate("/confirmforgotpassword");
// 		} catch (err) {
// 			console.error(err);
// 			setBanner({ text: translations[language].forgotPassword.toast.error, type: "error", exiting: false });
// 		} finally {
// 			setLoading(false);
// 		}
// 	}

// 	return (
// 		<div className="container">
// 			<div className="card" style={{ maxWidth: 400, margin: "40px auto" }}>
// 				<div className="hd">
// 					<div>{translations[language].forgotPassword.title}</div>
// 				</div>
// 				<div className="bd">
// 					<p className="sf-auth-sub">
// 						{translations[language].forgotPassword.subtitle}
// 					</p>
// 					<div className="row">
// 						<input
// 							type="email"
// 							className="input"
// 							placeholder={translations[language].forgotPassword.email}
// 							value={email}
// 							onChange={(e) => setEmail(e.target.value)}
// 							required
// 						/>
// 						<button
// 							className="btn brand"
// 							style={{ width: "100%" }}
// 							onClick={handleSubmit}
// 							disabled={loading}
// 						>
// 							{loading
// 								? translations[language].forgotPassword.sending
// 								: translations[language].forgotPassword.send}
// 						</button>
// 					</div>

// 					<BannerMessageFixed
// 						text={banner.text}
// 						type={banner.type}
// 						exiting={banner.exiting}
// 					/>
// 				</div>
// 			</div>
// 		</div>
// 	);
// };

// export default ForgotPassword;